export enum ProfileActionErrors {
    EmailUsedBySameCompanyCustomer = 'Email_Used_By_Same_Company_Customer',
    EmailUsedByAnotherCompanyCustomer = 'Email_Used_By_Another_Company_Customer',
    EmailExistsWithinAnotherAccount = 'Email_Exists_Within_Another_Account',
    InviteOneMoreChildAccountFailed = 'Invite_One_More_Child_Account_Failed'
}